import { useState, useEffect, useCallback } from "react";
import { getHocSinhById, getLichSuHocSinh, getDiemSoHocSinh, getLichSuDiemDanhHS } from "../services/hocSinhService";
import { tinhTrungBinh } from "../utils";

export const useStudentProfile = (hocSinhId, lopId, namHocHienTai = "2025-2026") => {
  const [student, setStudent] = useState(null);
  const [lichSu, setLichSu] = useState([]);
  const [diemSo, setDiemSo] = useState([]);
  const [diemDanhLS, setDiemDanhLS] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadData = useCallback(async () => {
    if (!hocSinhId) return;
    setLoading(true);
    try {
      const [hs, ls, ds, dd] = await Promise.all([
        getHocSinhById(hocSinhId), getLichSuHocSinh(hocSinhId),
        getDiemSoHocSinh(hocSinhId, namHocHienTai), getLichSuDiemDanhHS(hocSinhId, lopId)
      ]);
      setStudent(hs); setLichSu(ls||[]); setDiemSo(ds||[]); setDiemDanhLS(dd||[]);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  }, [hocSinhId, lopId, namHocHienTai]);

  useEffect(() => { loadData(); }, [loadData]);

  const stats = useCallback(() => {
    if (!diemDanhLS.length) return null;
    const t = diemDanhLS.length, cm = diemDanhLS.filter(d=>d.trangThai==='coMat').length;
    const dt = diemDanhLS.filter(d=>d.trangThai==='diTre').length;
    return { tong:t, coMat:cm, vangPhep:diemDanhLS.filter(d=>d.trangThai==='vangPhep').length,
      diTre:dt, vangKP:diemDanhLS.filter(d=>d.trangThai==='vangKhongPhep').length,
      chuyenCan: t>0?Math.round((cm+dt)/t*100):0 };
  }, [diemDanhLS]);

  const dTB = useCallback(() => {
    if(!diemSo.length) return null;
    const f = (l) => diemSo.filter(d=>d.loaiDiem===l).map(d=>d.diem);
    return tinhTrungBinh(f('mieng'), f('15phut'), f('1tiet'), (f('hocKy')[0]||0));
  }, [diemSo]);

  return { student, lichSu, diemSo, diemDanhLS: [...diemDanhLS].sort((a,b)=>b.ngayHoc.localeCompare(a.ngayHoc)),
    loading, stats: stats(), diemTB: dTB() };
};
